// src/pages/workflow-builder/NodeConfigModal.js
import React, { useState } from 'react';
import './NodeConfigModal.css';

const NodeConfigModal = ({ node, onClose, onSave }) => {
    // Common field for all node types
    const [label, setLabel] = useState(node.data.label || '');

    // Node-specific states
    const [leadStatus, setLeadStatus] = useState(node.data.leadStatus || '');
    const [aiPrompt, setAiPrompt] = useState(node.data.aiPrompt || '');
    const [messageContent, setMessageContent] = useState(node.data.messageContent || '');

    // For delayNode
    const [delayType, setDelayType] = useState(node.data.delayType || 'time-based');
    const [timeValue, setTimeValue] = useState(node.data.timeValue || '');
    const [timeUnit, setTimeUnit] = useState(node.data.timeUnit || 'hours');
    const [specificDateTime, setSpecificDateTime] = useState(node.data.specificDateTime || '');

    // For conditionalNode
    const [conditionalOption, setConditionalOption] = useState(node.data.conditionalOption || '');

    const handleSave = () => {
        const updatedData = { label };
        switch (node.type) {
            case 'leadNode':
                updatedData.leadStatus = leadStatus;
                break;
            case 'callNode':
                updatedData.aiPrompt = aiPrompt;
                break;
            case 'smsNode':
            case 'emailNode':
                updatedData.messageContent = messageContent;
                break;
            case 'delayNode':
                updatedData.delayType = delayType;
                if (delayType === 'time-based') {
                    updatedData.timeValue = timeValue;
                    updatedData.timeUnit = timeUnit;
                    updatedData.specificDateTime = '';
                } else {
                    updatedData.specificDateTime = specificDateTime;
                    updatedData.timeValue = '';
                    updatedData.timeUnit = '';
                }
                break;
            case 'conditionalNode':
                updatedData.conditionalOption = conditionalOption;
                updatedData.subLabel = conditionalOption ? `If: ${conditionalOption}` : '';
                break;
            default:
                break;
        }
        onSave(node.id, updatedData);
    };

    let nodeSpecificFields = null;
    if (node.type === 'leadNode') {
        nodeSpecificFields = (
            <div>
                <label>Lead Status</label>
                <select value={leadStatus} onChange={(e) => setLeadStatus(e.target.value)}>
                    <option value="">--Select Status--</option>
                    <option value="New">New</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Nurturing">Nurturing</option>
                    <option value="Qualified">Qualified</option>
                </select>
            </div>
        );
    } else if (node.type === 'callNode') {
        nodeSpecificFields = (
            <div>
                <label>AI Prompt</label>
                <select value={aiPrompt} onChange={(e) => setAiPrompt(e.target.value)}>
                    <option value="">--Select Prompt--</option>
                    <option value="Qualification">Qualification</option>
                    <option value="Phase 2">Phase 2</option>
                    <option value="Intake">Intake</option>
                </select>
            </div>
        );
    } else if (node.type === 'smsNode' || node.type === 'emailNode') {
        nodeSpecificFields = (
            <div>
                <label>Message Content</label>
                <textarea rows={4} value={messageContent} onChange={(e) => setMessageContent(e.target.value)} />
            </div>
        );
    } else if (node.type === 'delayNode') {
        nodeSpecificFields = (
            <div>
                <label>Delay Type</label>
                <div style={{ margin: '0.5rem 0' }}>
                    <label style={{ marginRight: '1rem' }}>
                        <input
                            type="radio"
                            value="time-based"
                            checked={delayType === 'time-based'}
                            onChange={() => setDelayType('time-based')}
                        />
                        Time Based
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="specific"
                            checked={delayType === 'specific'}
                            onChange={() => setDelayType('specific')}
                        />
                        Specific Date/Time
                    </label>
                </div>
                {delayType === 'time-based' ? (
                    <div className="time-based-section">
                        <label>Time Value</label>
                        <input
                            type="number"
                            value={timeValue}
                            onChange={(e) => setTimeValue(e.target.value)}
                            placeholder="e.g. 3"
                        />
                        <label>Time Unit</label>
                        <select value={timeUnit} onChange={(e) => setTimeUnit(e.target.value)}>
                            <option value="minutes">Minutes</option>
                            <option value="hours">Hours</option>
                            <option value="days">Days</option>
                        </select>
                    </div>
                ) : (
                    <div className="specific-datetime-section">
                        <label>Select Date/Time</label>
                        <input
                            type="datetime-local"
                            value={specificDateTime}
                            onChange={(e) => setSpecificDateTime(e.target.value)}
                        />
                    </div>
                )}
            </div>
        );
    } else if (node.type === 'conditionalNode') {
        nodeSpecificFields = (
            <div>
                <label>Conditional Option</label>
                <select value={conditionalOption} onChange={(e) => setConditionalOption(e.target.value)}>
                    <option value="">--Select Option--</option>
                    <option value="No Answer">No Answer</option>
                    <option value="Voicemail">Voicemail</option>
                    <option value="Hung up">Hung up</option>
                </select>
            </div>
        );
    }

    return (
        <div className="node-config-overlay">
            <div className="node-config-modal">
                <h3>Edit Node: {node.type}</h3>
                <label>Label</label>
                <input type="text" value={label} onChange={(e) => setLabel(e.target.value)} />
                {nodeSpecificFields}
                <div className="modal-buttons">
                    <button onClick={onClose} className="cancel-btn">
                        Cancel
                    </button>
                    <button onClick={handleSave} className="save-btn">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NodeConfigModal;
